import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { productDataViewSelector } from "@store/Store/Components/RsswYMMD/RsswYMMDSelector";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import ProductFitType, {
    ProductFitTypeStyles,
    RsswProductContextModel,
} from "@store/Widgets/Components/ProductFitType";
import { rsswProductModel } from "@store/Widgets/ProductList/RsswProductModel";
import React from "react";
import { useSelector } from "react-redux";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsModelNameStyles {
    wrapper?: InjectableCss;
    modelName?: TypographyProps;
    fitType?: ProductFitTypeStyles;
}

export const productDetailsModelNameStyles: ProductDetailsModelNameStyles = {
    wrapper: {
        css: css`
            display: flex;
            align-items: center;
            margin-bottom: 15px;
        `,
    },
    modelName: {
        ...rsswProductModel,
        css: css`
            padding-right: 20px;
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [
                        { values: ["22px", null, "30px", null, null], properties: ["font-size"] },
                        { values: ["auto", null, "0", null, null], properties: ["margin-right"] },
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    fitType: {
        wrapperMultiFit: {
            css: css`
                display: flex;
                align-items: center;
            `,
        },
        wrapperDirectFit: {
            css: css`
                display: flex;
                align-items: center;
            `,
        },
    },
};

const styles = productDetailsModelNameStyles;

const ProductDetailsModelName = ({ product }: Props) => {
    if (!product || product.detail?.modelNumber === "") {
        return null;
    }

    const ymmdProducts = useSelector(productDataViewSelector);
    const currentYmmdProduct = ymmdProducts.productsIds.filter(item => {
        return item.productId === product.id;
    });

    const productWithFit: RsswProductContextModel = {
        product: {
            fit: currentYmmdProduct[0]?.fit,
            ...product,
        },
    };

    if (product.detail?.modelNumber === "" && !productWithFit) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.modelName}>{product.detail?.modelNumber}</Typography>
            <ProductFitType product={productWithFit} extendedStyles={styles.fitType} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsModelName),
    definition: {
        displayName: "Rssw Model Name",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
